import * as tslib_1 from "tslib";
import axios from 'axios';
/**
 * class PrivateMediaService
 */
var PrivateMediaService = /** @class */ (function () {
    function PrivateMediaService() {
    }
    /**
     * for more information see (https://kb.wixpress.com/pages/viewpage.action?pageId=46730383)
     * @param {{}} params
     * @param token
     * @return {Promise<AxiosResponse<T>>}
     */
    PrivateMediaService.prototype.getFileUploadUrl = function (params, token) {
        if (params === void 0) { params = {}; }
        return axios.get(PrivateMediaService.WIX_FILES + "/site/media/files/upload/url", {
            params: params,
            headers: {
                Authorization: token,
            },
        });
    };
    /**
     * @param {File} image
     * @param authToken - The Private Media Service verifies wixSession2 cookie (JWT token) in order to authenticate client-to-server requests.
     */
    PrivateMediaService.prototype.uploadImage = function (image, authToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, upload_url, upload_token, formData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getFileUploadUrl({
                            media_type: 'picture',
                        }, authToken)];
                    case 1:
                        _a = (_b.sent()).data, upload_url = _a.upload_url, upload_token = _a.upload_token;
                        formData = new FormData();
                        formData.set('upload_token', upload_token);
                        formData.set('file', image);
                        return [2 /*return*/, axios.post(upload_url, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })];
                }
            });
        });
    };
    PrivateMediaService.WIX_FILES = 'https://files.wix.com';
    return PrivateMediaService;
}());
export { PrivateMediaService };
//# sourceMappingURL=PrivateMediaService.js.map